import { Injectable } from '@angular/core';
import * as Parse from 'parse';

@Injectable()
export class ParseService {
    constructor() {
        Parse.initialize('openinc');
        (Parse as any).serverURL = 'https://parse-demo.apps.openinc.dev/parse';
    }

    public async become(sessionId: string) {
        return (await Parse.User.become(sessionId)).toJSON();
    }

    public async logIn(username: string, password: string): Promise<any> {
        const user = await Parse.User.logIn(username, password, { useMasterKey: false });
        if (user) return user.toJSON();
    }

    public async logOut(): Promise<void> {
        await Parse.User.logOut();
    }

    public async getCurrentUser() {
        const currentUser = Parse.User.current();
        if (currentUser) return currentUser;
        else return null;
    }
}
